import { Key } from './keys';

export const handleEscapeKey =
  (handler?: React.KeyboardEventHandler) =>
  (event: React.KeyboardEvent): void => {
    if (event.code !== Key.ESCAPE) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    return handler?.(event);
  };
